import {Line} from './line.model';


export class Field {
  id: string;
  name: string;
  createdAt: string = new Date().toString();
  description: string;
  lines: Line[] = [];
}
